import React from "react";
import { motion } from "framer-motion";
import "./Events.css";
import event1 from "../assets/gallery/1 (11).jpg";
import event2 from "../assets/gallery/comingsoon.png";

const events = [
  {
    id: 1,
    title: "Sreenathji Enterprises & MKS Atotech Host Insightful Seminar on Next-Generation Metal Finishing Technologies.",
    img: event1,
  },
  {
    id: 2,
    title: "All our recent events have concluded. Stay tuned for upcoming events!",
    img: event2,
  },
];

const Events = () => {
  return (
    <section id="events" className="events">
<div className="events-header">
  <div>
    {/* Tag (slide from top) */}
    <motion.span
      className="events-tag"
      initial={{ opacity: 0, y: -40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      viewport={{ amount: 0.3 }}
    >
      Events
    </motion.span>

    {/* Heading (slide from bottom) */}
    <motion.h2
      initial={{ opacity: 0, y: 60 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut", delay: 0.1 }}
      viewport={{ amount: 0.3 }}
    >
      Insights from our <br />
      <span>latest Events</span>
    </motion.h2>
  </div>

  <div className="events-header-text">
    {/* Paragraph (fade + slide up) */}
    <motion.p
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
      viewport={{ amount: 0.3 }}
    >
      Through active participation in industry events, we stay connected with emerging trends, collaborations, and next-generation advancements.
    </motion.p>
  </div>
</div>
      <div className="event-list">
        {events.map((event, idx) => (
          <motion.div
            className="event-card"
            key={event.id}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: idx * 0.2 }}
            viewport={{ once: true }}
            whileHover={{ scale: 1.03 }}
          >
            <img src={event.img} alt={event.title} />
            <div className="event-content">
              <h4>{event.title}</h4>
              <button
  className="event-btn"
  onClick={() => (window.location.href = "/events")}
>
  ➜
</button>

            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Events;
